import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { BASE_SUFFIXES } from '../translation-suffixes';
import { PartialsHelpersService } from '../partials-helpers.service';
import { CardComponent } from '../../../shared/components/card/card.component';
import { SideBySideComponent } from '../../../shared/components/side-by-side/side-by-side.component';
import { InlineBannerComponent } from '../../../shared/components/inline-banner/inline-banner.component';

@Component({
    selector: 'vision2-section-2',
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        CardComponent,
        InlineBannerComponent,
        SideBySideComponent,
    ],
    templateUrl: './section-2.component.html',
    styleUrl: './section-2.component.scss',
})
export class Section2Component implements OnChanges {
    @Input() productData: any;
    groupedContent: Record<string, any[]> = {};
    hasValidTranslations = false;

    constructor(private helpers: PartialsHelpersService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getTranslations();
    }

    getTranslations(): void {
        this.groupedContent = {
            'SECTION-2': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-2',
                BASE_SUFFIXES,
                [],
            ),
            // Inline banners for Section-2
            'SECTION-2_INLINE-BANNER': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-2_INLINE-BANNER',
                BASE_SUFFIXES,
                [0, 1], // Supports two inline banners
            ),
            // Side by Sides
            'SECTION-2_SIDE-BY-SIDE': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-2_SIDE-BY-SIDE',
                BASE_SUFFIXES,
                [0, 1],
            ),
            //Content Blocks
            'SECTION-2_CONTENT-BLOCK': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-2_CONTENT-BLOCK',
                BASE_SUFFIXES,
                [0, 1],
            ),
        };

        this.hasValidTranslations = this.helpers.hasValidTranslation(
            this.groupedContent,
        );
    }
}
